import { render, staticRenderFns } from "./_pageHead.vue?vue&type=template&id=522cfa1a&"
import script from "./_pageHead.vue?vue&type=script&lang=js&"
export * from "./_pageHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports